module.exports = __webpack_public_path__ + "public-ui/img/alpha.24d3e4a3.svg";